import { useState } from "react"
import LoginCard from "../../components/LoginCard"
import SignupCard from "../../components/SignupCard"

import {
  Card,
  CardContent,
  LinearProgress,
  Tabs,
  Tab
} from '@mui/material'

import { useDispatch, useSelector } from "react-redux"
import { CLEAR_ERRORS } from "../../constants/globalConstants"

const Login = () => {
  const [value, setValue] = useState(0)
  const dispatch = useDispatch()
  const { loading } = useSelector(state => state.userState)

  const handleChange = (event, newValue) => {
    setValue(newValue)
    dispatch({ type: CLEAR_ERRORS })
  }

  return (
    <Card sx={{ maxWidth: 650, mt: 5, mx: 'auto' }}>
      {loading && <LinearProgress />}
      <CardContent sx={{ p: 3 }}>
        <Tabs sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }} value={value} onChange={handleChange}>
          <Tab label='Login' />
          <Tab label='Signup' />
        </Tabs>
        {value === 0 && <LoginCard />}
        {value === 1 && <SignupCard />}
      </CardContent>
    </Card>
  )
}

export default Login